(() => {
  const currency = window.Shopify?.currency?.active || 'USD';
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents || 0) / 100);
  const announce = (message) => {
    const region = document.querySelector('[data-storefront-status]');
    if (region) region.textContent = message;
  };
  const notice = document.querySelector('[data-cart-feedback]');
  const dismissFeedback = () => { if (notice) notice.hidden = true; };
  const feedback = (message, form = null) => {
    const inline = form?.querySelector('[data-product-message]');
    if (inline) inline.textContent = message;
    if (!notice) return;
    const modal = document.querySelector('dialog:modal');
    (modal || document.body).appendChild(notice);
    notice.querySelector('[data-cart-feedback-message]').textContent = message;
    notice.hidden = false;
  };
  document.addEventListener('click', event => { if (event.target.closest('[data-cart-feedback-close]')) dismissFeedback(); });
  let drawerTrigger = null;
  let drawerIsOpen = false;
  const setDrawer = (open) => {
    drawerIsOpen = open;
    if (open) dismissFeedback();
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', String(!open));
    document.documentElement.classList.toggle('cartDrawerOpen', open);
    document.querySelectorAll('[data-cart-drawer-open]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
    drawer.inert = !open;
    if (open) drawer.querySelector('.cartDrawerPanel [data-cart-drawer-close]')?.focus({preventScroll:true});
    else if (drawerTrigger?.isConnected && !drawerTrigger.disabled) drawerTrigger.focus({preventScroll:true});
    else document.querySelector('[data-cart-drawer-open]')?.focus({preventScroll:true});
  };
  const refreshCartDrawer = async () => {
    const response = await fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Your cart could not be refreshed.');
    const sections = await response.json();
    const html = sections['cart-drawer'];
    if (!html) throw new Error('Your cart changed, but the view could not refresh. Open the cart page to check it.');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const current = document.querySelector('#shopify-section-cart-drawer');
    const updated = parsed.querySelector('#shopify-section-cart-drawer');
    if (!current || !updated) throw new Error('Your cart changed, but the view could not refresh. Open the cart page to check it.');
    // Keep the open drawer shell mounted so quantity changes do not replay
    // its entrance animation or send a scrolled bag back to the first item.
    const panel = current.querySelector('.cartDrawerPanel');
    const nextPanel = updated.querySelector('.cartDrawerPanel');
    if (!panel || !nextPanel) throw new Error('Open the cart page to review your updated bag.');
    const scrollTop = panel.querySelector('.cartDrawerBody')?.scrollTop || 0;
    const active = document.activeElement;
    const hadFocus = panel.contains(active);
    const key = active?.dataset?.cartChange;
    const label = active?.getAttribute('aria-label');
    panel.replaceChildren(...nextPanel.childNodes);
    document.dispatchEvent(new CustomEvent('sincere:cart-rendered'));
    const body = panel.querySelector('.cartDrawerBody');
    if (body) body.scrollTop = scrollTop;
    if (hadFocus && drawerIsOpen) {
      const replacement = key && [...panel.querySelectorAll('[data-cart-change]')].find(node => node.dataset.cartChange === key && node.getAttribute('aria-label') === label);
      (replacement || panel.querySelector('[data-cart-drawer-close]'))?.focus({preventScroll:true});
    }
  };
  const updateBubble = async () => {
    try {
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => {
        if (!r.ok) throw new Error('Unable to load bag');
        return r.json();
      });
      document.querySelectorAll('[data-bag-count]').forEach(n => { const count = Number(cart.item_count) || 0; n.textContent = count > 0 ? String(count) : ''; n.hidden = count === 0; });
      document.querySelectorAll('[data-cart-drawer-open]').forEach(n => n.setAttribute('aria-label', 'Open cart with ' + (cart.item_count || 0) + (cart.item_count === 1 ? ' item' : ' items')));
    } catch (error) { announce(error.message); }
  };
  const submitProductForm = async (form, button) => {
    if (form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    dismissFeedback();
    const original = button?.textContent;
    const message = form.querySelector('[data-product-message]');
    if (message) message.textContent = '';
    const reset = () => {
      form.dataset.submitting = 'false';
      if (!button) return;
      button.textContent = button.dataset.purchaseLabel || original;
      button.disabled = button.dataset.purchaseUnavailable === 'true';
      button.removeAttribute('aria-busy');
      delete button.dataset.addState;
    };
    try {
      if (button) { button.textContent = 'Adding to cart…'; button.disabled = true; button.setAttribute('aria-busy','true'); button.dataset.addState='adding'; }
      // The quick-add size tray has no hidden id field — each size is its own
      // `<button name="id" value="{variant.id}">`, meant to be read from the
      // submitter. `new FormData(form)` alone drops that pair, so every
      // quick-add posted with no variant id and cart/add.js 400'd on every
      // single click. Passing the submitter is what actually includes it;
      // the manual fallback covers submitters FormData's second argument
      // doesn't support (only true <button> elements, not <input type=submit>).
      const formData = new FormData(form);
      if (button?.name) formData.set(button.name, button.value);
      if (button?.name && !formData.has(button.name)) formData.set(button.name, button.value);
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept':'application/json' }, body: formData });
      const result = await res.json();
      if (!res.ok) throw new Error(result.description || 'This option could not be added.');
      await updateBubble();
      let drawerReady = true;
      try { await refreshCartDrawer(); }
      catch (error) { drawerReady = false; feedback('Added to your cart. Open your cart to review it; the preview could not refresh.', form); }
      if (button) {button.textContent = 'Added to cart ✓';button.removeAttribute('aria-busy');button.dataset.addState='added';}
      if (drawerReady) announce('Added to your cart.');
      if (drawerReady && form.closest('[data-quick-size-panel]')) feedback('Added to your cart. Keep exploring or review your selection.');
      // Quick-add on a collection card auto-opening the drawer put its
      // full-screen backdrop over the rest of the grid, so the very next
      // product's "+" click landed on the backdrop and just closed the bag
      // instead of adding anything — it looked like the cart kept getting
      // wiped out. Grid quick-adds now only bump the bag badge and let the
      // "Added" label confirm it; the full-page product form still opens
      // the drawer since there's no grid behind it to block.
      if (drawerReady && !form.closest('[data-quick-size-panel]')) {
        drawerTrigger = button;
        setDrawer(true);
      }
      window.setTimeout(reset, 1100);
    } catch (error) {
      if (button) {button.textContent = 'Try again';button.removeAttribute('aria-busy');button.dataset.addState='error';}
      feedback(error instanceof TypeError ? 'The connection was interrupted. Check your cart before trying again.' : error.message, form);
      window.setTimeout(reset, 1400);
    }
  };
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-shopify-add-form]');
    if (!form) return;
    event.preventDefault();
    submitProductForm(form, event.submitter || form.querySelector('button[type="submit"]'));
  });
  document.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-cart-change]');
    if (!control) return;
    const line = control.closest('[data-cart-line]');
    const key = control.dataset.cartChange;
    const controlLabel = control.getAttribute('aria-label');
    const qty = Number(control.dataset.quantity || 0);
    if (document.documentElement.dataset.cartUpdating) return;
    document.documentElement.dataset.cartUpdating = 'true';
    control.disabled = true;
    dismissFeedback();
    if (qty === 0 && line) line.classList.add('isRemoving');
    window.setTimeout(async () => {
      try {
        const res = await fetch(root + 'cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) });
        if (!res.ok) {
          const error = await res.json().catch(() => ({}));
          throw new Error(error.description || 'Your cart could not be updated. Please try again.');
        }
        // A full reload here was the cause of the drawer/line-items vanishing on every
        // +/- click: the reload lands back on the Liquid default (drawer closed), which
        // looks like the whole cart UI disappeared. Refresh the section in place instead,
        // same as add-to-bag does, and re-open the drawer since replacing the section
        // resets its aria-hidden state.
        if (control.closest('.cartPage')) { window.location.reload(); return; }
        await updateBubble();
        await refreshCartDrawer();
        if (drawerIsOpen && qty > 0 && controlLabel) {
          const replacement = [...document.querySelectorAll('[data-cart-change]')].find(n => n.dataset.cartChange === key && n.getAttribute('aria-label') === controlLabel);
          replacement?.focus({preventScroll:true});
        }
        announce('Your cart was updated.');
      } catch (error) {
        control.disabled = false;
        line?.classList.remove('isRemoving');
        feedback(error instanceof TypeError ? 'The connection was interrupted. Check your cart before trying again.' : error.message);
      } finally {
        delete document.documentElement.dataset.cartUpdating;
        if (control.isConnected) control.disabled = false;
      }
    }, qty === 0 && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 180 : 0);
  });
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-drawer-open]');
    if (opener) { drawerTrigger = opener; setDrawer(true); return; }
    if (event.target.closest('[data-cart-drawer-close]')) setDrawer(false);
  });
  document.addEventListener('keydown', (event) => {
    const drawer = document.querySelector('[data-cart-drawer][aria-hidden="false"]');
    if (!drawer) return;
    if (event.key === 'Escape') { setDrawer(false); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('.cartDrawerPanel a[href], .cartDrawerPanel button:not([disabled]), .cartDrawerPanel input:not([disabled]), .cartDrawerPanel select:not([disabled])')].filter((node) => node.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  let quickControlIndex=0;
  const identifyQuickAdds=()=>document.querySelectorAll('[data-quick-size-panel]').forEach(panel=>{if(panel.dataset.controlReady)return;panel.dataset.controlReady='true';const controlId='QuickAddRuntime-'+(++quickControlIndex);panel.setAttribute('id',controlId);panel.closest('[data-product-card]')?.querySelector('[data-quick-add-toggle]')?.setAttribute('aria-controls',controlId);});
  identifyQuickAdds();document.addEventListener('sc:cards-added',identifyQuickAdds);
  const closeQuickAdds = (except) => {
    document.querySelectorAll('[data-product-card].isQuickOpen').forEach((card) => {
      if (card === except) return;
      card.classList.remove('isQuickOpen');
      card.querySelector('[data-quick-add-toggle]')?.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.quickAdd.isOpen').forEach((legacy) => {
      if (legacy.closest('[data-product-card]') === except) return;
      legacy.classList.remove('isOpen');
      legacy.querySelector('.quickToggle')?.setAttribute('aria-expanded', 'false');
    });
  };
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-quick-add-toggle], .quickToggle');
    if (!toggle) {
      // A click anywhere else dismisses any open size tray.
      if (!event.target.closest('[data-quick-size-panel], .sizeTray')) closeQuickAdds(null);
      return;
    }
    event.preventDefault();
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    const card = toggle.closest('[data-product-card]');
    closeQuickAdds(expanded ? null : card);
    toggle.setAttribute('aria-expanded', String(!expanded));
    card?.classList.toggle('isQuickOpen', !expanded);
    toggle.closest('.quickAdd')?.classList.toggle('isOpen', !expanded);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {const card=event.target.closest('[data-product-card].isQuickOpen');closeQuickAdds(null);card?.querySelector('[data-quick-add-toggle]')?.focus();}
  });
  // Colourway swatches restyle the card in place and re-point it at that variant.
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.colorSwatch');
    if (!swatch) return;
    const card = swatch.closest('[data-product-card]');
    if (!card) return;
    event.preventDefault();
    const name = swatch.dataset.colorName || '';
    card.style.setProperty('--card-tone-a', swatch.dataset.toneA || '');
    card.style.setProperty('--card-tone-b', swatch.dataset.toneB || '');
    card.dataset.selectedColor = name;
    const label = card.querySelector('[data-card-color]');
    if (label) label.textContent = name;
    // The swatch only re-tinted the card background before — the garment
    // photo itself never changed, so picking White visually did nothing.
    // Swap the actual flat-shot image to the colour that was clicked.
    if (swatch.dataset.flatImage) {
      const flatImg = card.querySelector('[data-card-flat-image]');
      if (flatImg) { flatImg.src = swatch.dataset.flatImage; flatImg.removeAttribute('srcset'); }
    }
    card.querySelectorAll('.colorSwatch').forEach((node) => {
      const active = node === swatch;
      node.classList.toggle('isSelected', active);
      node.setAttribute('aria-pressed', String(active));
    });
    card.querySelectorAll('[data-variant-color]').forEach(node => { node.hidden = node.dataset.variantColor !== name; });
    const cardPrice = card.querySelector('[data-card-price]');
    if (cardPrice && swatch.dataset.variantPrice) cardPrice.textContent = swatch.dataset.variantPrice;
    const alternate = card.querySelector('[data-card-body-image]');
    if (alternate && swatch.dataset.flatImage) { alternate.src = swatch.dataset.flatImage; alternate.removeAttribute('srcset'); }
    card.dispatchEvent(new CustomEvent('sincere:colour-change', {bubbles:true}));
    const base = card.dataset.productUrl;
    if (base) {
      const url = base + (base.includes('?') ? '&' : '?') + 'variant=' + encodeURIComponent(swatch.dataset.variantId || '');
      card.querySelector('.productCardLink')?.setAttribute('href', url);
    }
  });
  document.querySelectorAll('[data-submit-on-change], [data-localization-select]').forEach((select) => select.addEventListener('change', () => select.form?.submit()));
  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    const summary = menu.querySelector('summary');
    const panel = menu.querySelector('.mobileMenuPanel');
    const focusable = () => [summary, ...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary')].filter(n => n.getClientRects().length && !n.closest('[hidden], [inert]'));
    menu.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('mobileMenuOpen', menu.open);
      summary.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
      if (menu.open) panel.querySelector('a[href]')?.focus();
    });
    menu.addEventListener('keydown', (event) => {
      if (!menu.open) return;
      if (event.key === 'Escape') { event.preventDefault(); menu.open = false; summary.focus(); return; }
      if (event.key !== 'Tab') return;
      const items = focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('click', (event) => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
  });
  document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
    const input = form.querySelector('[data-predictive-search-input]');
    const results = form.querySelector('[data-predictive-search-results]');
    let timer;
    let sequence = 0;
    let controller;
    const cache = new Map();
    input?.addEventListener('input', () => {
      const requestSequence = ++sequence;
      window.clearTimeout(timer);
      controller?.abort();
      const query = input.value.trim();
      if (query.length < 2) { results.hidden = true; results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      if (cache.has(query)) { results.innerHTML = cache.get(query); results.hidden = !results.textContent.trim(); input.setAttribute('aria-expanded', String(!results.hidden)); return; }
      timer = window.setTimeout(async () => {
        controller = new AbortController();
        try {
          const url = `${root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`;
          const response = await fetch(url, { headers: { Accept: 'text/html' }, signal: controller.signal });
          if (!response.ok) throw new Error('Search suggestions are unavailable.');
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          if (requestSequence !== sequence) return;
          results.innerHTML = parsed.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
          if (cache.size >= 20) cache.delete(cache.keys().next().value);
          cache.set(query, results.innerHTML);
          results.hidden = !results.textContent.trim();
          input.setAttribute('aria-expanded', String(!results.hidden));
        } catch (error) { if (error.name === 'AbortError' || requestSequence !== sequence) return; results.hidden = true; input.setAttribute('aria-expanded', 'false'); announce(error.message); }
      }, 220);
    });
    const closeSuggestions = () => { ++sequence; controller?.abort(); window.clearTimeout(timer); results.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    form.addEventListener('click', event => { if(event.target.closest('[data-search-close]')) { closeSuggestions(); input.focus(); } });
    form.addEventListener('keydown', event => { if(event.key === 'Escape') { closeSuggestions(); input.focus(); } });
    input?.addEventListener('keydown', (event) => {
      if(event.key === 'ArrowDown' && !results.hidden) { const link=results.querySelector('a'); if(link) { event.preventDefault(); link.focus(); } }
      if (event.key === 'Escape') { ++sequence; controller?.abort(); window.clearTimeout(timer); results.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    });
  });
  const initProduct = (productRoot) => {
    const data = productRoot.querySelector('[data-product-json]');
    if (!data) return;
    let variants = [];
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    const form = productRoot.querySelector('.productPurchase');
    const idInput = form?.querySelector('[data-variant-id]');
    const optionGroups = [...productRoot.querySelectorAll('[data-option-position]')].sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition));
    const selectedOptions = () => optionGroups.map((group) => group.querySelector('.optionValue.isSelected')?.dataset.optionValue || '');
    const findVariant = () => variants.find((variant) => variant.options.every((value, index) => value === selectedOptions()[index]));
    const markAvailability = () => {
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const candidate = selectedOptions();
          candidate[groupIndex] = button.dataset.optionValue;
          const possible = variants.some((variant) => variant.available && variant.options.every((value, index) => value === candidate[index]));
          button.classList.toggle('isUnavailable', !possible);
        });
      });
    };
    const paintPurchase=()=>{const selected=productRoot.querySelector('.pdpSwatches .isSelected');const color=selected?getComputedStyle(selected).getPropertyValue('--swatch-color').trim():'#111111';if(!/^#[0-9a-f]{6}$/i.test(color))return;const rgb=[1,3,5].map(i=>parseInt(color.slice(i,i+2),16)/255).map(c=>c<=.04045?c/12.92:((c+.055)/1.055)**2.4);const luminance=rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722;productRoot.style.setProperty('--purchase-color',color);productRoot.style.setProperty('--purchase-ink',luminance>.179?'#111111':'#ffffff');productRoot.style.setProperty('--purchase-border',luminance>.8?'#b0aca5':color);};
    const update = (variant) => {
      paintPurchase();
      const earn=productRoot.querySelector("[data-cmty-earn]");if(earn&&variant)earn.textContent=String(Math.round(variant.price*Number(productRoot.dataset.cmtyRate||1274)/100000));
      const available = Boolean(variant?.available);
      const initialPrelaunch = productRoot.dataset.initialPrelaunch === 'true';
      const prelaunch = Boolean(variant) && !available && productRoot.dataset.prelaunchEnabled === 'true';
      if (variant && prelaunch !== initialPrelaunch && productRoot.dataset.prelaunchEnabled === 'true') {
        const destination = new URL(window.location.href);
        destination.searchParams.set('variant', variant.id);
        window.location.assign(destination.href);
        return;
      }
      const accelerated = productRoot.querySelector('[data-accelerated-checkout]');
      if (accelerated) accelerated.hidden = !available;
      productRoot.querySelectorAll('[data-notify-toggle], [data-sticky-notify]').forEach(button => {
        button.disabled = !variant;
      });
      const addButton = form?.querySelector('[data-add-to-bag]');
      const stickyButton = productRoot.querySelector('[data-sticky-add]');
      if (idInput) idInput.value = variant?.id || '';
      productRoot.dispatchEvent(new CustomEvent('sincere:variant-change', {detail:{variant}}));
      [addButton, stickyButton].forEach((button) => {
        if (!button) return;
        button.dataset.purchaseUnavailable = String(!available);
        button.dataset.purchaseLabel = variant ? (available ? 'Add to Cart' : 'Sold out') : 'Unavailable';
        button.disabled = !available || form?.dataset.submitting === 'true';
        if (form?.dataset.submitting !== 'true') button.textContent = button.dataset.purchaseLabel;
      });
      const stockCopy = productRoot.querySelector('[data-stock-copy]');
      const levels = JSON.parse(productRoot.querySelector('[data-stock-levels]')?.textContent || '{}');
      const labels = JSON.parse(productRoot.querySelector('[data-stock-labels]')?.textContent || '{}');
      const level = available ? (levels[String(variant.id)] || 'available') : 'unavailable';
      const stockStatus = productRoot.querySelector('[data-stock-status]');
      if (stockStatus) stockStatus.dataset.stockStatus = prelaunch ? 'prelaunch' : level;
      if (stockCopy) stockCopy.textContent = prelaunch ? productRoot.dataset.prelaunchCopy : (labels[level] || (available ? 'Available' : 'Unavailable'));
      const editLink=productRoot.querySelector('[data-build-piece]');
      if(editLink){const editUrl=new URL(editLink.href);if(variant)editUrl.searchParams.set('variant',variant.id);else editUrl.searchParams.delete('variant');editLink.href=editUrl.pathname+editUrl.search;}
      const enquiry = productRoot.querySelector('.scEnquiry');
      if (enquiry && enquiry.getAttribute('href')?.startsWith('/pages/contact?')) {
        const enquiryUrl = new URL(enquiry.href);
        enquiryUrl.searchParams.set('variant', variant?.title || selectedOptions().join(' / '));
        enquiry.href = enquiryUrl.pathname + enquiryUrl.search;
      }
      const dot = productRoot.querySelector('.stockDot');
      dot?.classList.toggle('soldOut', !available);
      dot?.classList.toggle('inStock', available);
      const prices = JSON.parse(productRoot.querySelector('[data-product-prices]')?.textContent || '{}');
      const variantPrices = variant ? prices[String(variant.id)] : null;
      const formattedPrice = !variant || (!available && variant.price === 0) ? (labels.unavailable || 'Unavailable') : (variantPrices?.price || money(variant.price) + ' ' + currency);
      const price = productRoot.querySelector('[data-product-price]');
      if (price) {
        price.replaceChildren();
        if (variant && variant.compare_at_price > variant.price) {
          const compare = document.createElement('s');
          compare.textContent = variantPrices?.compare || money(variant.compare_at_price) + ' ' + currency;
          price.append(compare);
        }
        const amount = document.createElement('span');
        amount.textContent = formattedPrice;
        price.append(amount);
      }
      const stickyPrice = productRoot.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formattedPrice;
      markAvailability();
      if (!variant) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if(variant.featured_media?.id&&!productRoot.dataset.rcGalleryReady){const gallery=productRoot.querySelector('.pdpGallery'),frame=productRoot.querySelector(`[data-media-id="${variant.featured_media.id}"]`);if(gallery&&frame)gallery.scrollTo({left:[...gallery.querySelectorAll('.pdpFrame')].indexOf(frame)*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
      markAvailability();
    };
    productRoot.addEventListener('click', (event) => {
      const button = event.target.closest('[data-option-value]');
      if (!button) return;
      const group = button.closest('[data-option-position]');
      group.querySelectorAll('[data-option-value]').forEach((item) => { item.classList.remove('isSelected'); item.setAttribute('aria-pressed', 'false'); });
      button.classList.add('isSelected');
      button.setAttribute('aria-pressed', 'true');
      const selectedLabel = group.querySelector('[data-selected-option]');
      if (selectedLabel) selectedLabel.textContent = button.dataset.optionValue;
      update(findVariant());
    });
    productRoot.querySelector('[data-sticky-add]')?.addEventListener('click', () => form?.requestSubmit(form.querySelector('[data-add-to-bag]')));
    markAvailability();
    paintPurchase();
  };
  document.querySelectorAll('[data-product-root]').forEach(initProduct);
  document.querySelectorAll('[data-product-recommendations]').forEach(async (container) => {
    if (!container.dataset.url || container.querySelector('[data-product-card]')) return;
    try {
      const response = await fetch(container.dataset.url);
      if (!response.ok) return;
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector('[data-product-recommendations]');
      if (replacement?.textContent.trim()) {container.replaceWith(replacement);document.dispatchEvent(new CustomEvent('sc:cards-added'));}
    } catch (_) { /* Recommendations are optional and must fail silently. */ }
  });
  // Campaign motion: pause the gradient treatment and any real footage together.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-toggle-video]');
    if (!button) return;
    const card = button.closest('[data-video-card]');
    if (!card) return;
    const paused = card.classList.toggle('isPaused');
    button.setAttribute('aria-pressed', String(paused));
    button.textContent = paused ? 'Play motion' : 'Pause motion';
    const video = card.querySelector('video');
    if (video) { paused ? video.pause() : video.play().catch(() => {}); }
  });
  // The mega menu opens on hover via CSS :has(). This adds keyboard and touch parity.
  document.querySelectorAll('[data-nav-shell]').forEach((shell) => {
    const trigger = shell.querySelector('[data-shop-trigger]');
    const flyout = shell.querySelector('[data-shop-flyout]');
    if (!trigger || !flyout) return;
    const setOpen = (open) => {
      shell.classList.toggle('isMenuOpen', open);
      trigger.setAttribute('aria-expanded', String(open));
    };
    trigger.addEventListener('click', (event) => {
      // Coarse pointers get a toggle; mouse users keep the hover behaviour and the link.
      if (window.matchMedia('(hover: hover)').matches) return;
      event.preventDefault();
      setOpen(!shell.classList.contains('isMenuOpen'));
    });
    // The CSS :has(.primaryNav:hover) trigger only stays true while the pointer
    // sits over the "Shop" link itself. The instant the pointer moves down into
    // the flyout, that hover is lost, pointer-events flips to none synchronously
    // (it isn't in the transition list), and the flyout can never hand hover
    // back to itself — the menu closes before you can reach "Browse". Driving
    // isMenuOpen from real mouseenter/mouseleave on the whole shell removes the
    // gap: it only cares whether the pointer is anywhere inside trigger+flyout.
    if (window.matchMedia('(hover: hover)').matches) {
      trigger.addEventListener('mouseenter', () => setOpen(true));
    }
    trigger.addEventListener('focus', () => setOpen(true));
    shell.addEventListener('focusout', () => {
      window.setTimeout(() => { if (!shell.contains(document.activeElement)) setOpen(false); }, 0);
    });
    shell.addEventListener('mouseleave', () => setOpen(false));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setOpen(false); });
    document.addEventListener('click', (event) => { if (!shell.contains(event.target)) setOpen(false); });
  });
  const syncIdentityMotion = () => {
    document.querySelectorAll('[data-identity-motion]').forEach((section) => {
      const rect = section.getBoundingClientRect();
      const travel = Math.max(1, section.offsetHeight - window.innerHeight);
      const progress = Math.max(0, Math.min(1, -rect.top / travel));
      section.style.setProperty('--identity-progress', progress.toFixed(3));
    });
  };
  window.addEventListener('scroll', syncIdentityMotion, { passive: true });
  window.addEventListener('resize', syncIdentityMotion, { passive: true });
  const closedDrawer = document.querySelector('[data-cart-drawer][aria-hidden="true"]');
  if (closedDrawer) closedDrawer.inert = true;
  updateBubble(); syncIdentityMotion();
})();
